var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.86 18.01C20.23 18.01 20.47 17.62 20.31 17.29C19.62 15.92 19.3 14.76 19.13 13.93C18.84 12.47 18.77 10.93 18.77 10.93C18.72 9.91 18.79 9.63 18.66 8.87C18.58 8.37 18.42 7.44 17.84 6.42C17.14 5.17 16.19 4.46 15.76 4.17C15.3 3.86 13.97 3.04 12.1 3.02C11.75 3.02 9.19 3.06 7.27 4.95C6.31 5.9 5.67 7.12 5.39 8.44C5.19 9.4 5.22 10.38 5.18 11.36C5.14 12.32 4.99 13.26 4.78 14.2C4.5 15.46 4.08 16.5 3.69 17.29C3.53 17.62 3.77 18.01 4.14 18.01C9.38 18.01 14.62 18.02 19.86 18.03V18.01Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H15",
    stroke: "#50B84A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSimple);
export default __webpack_public_path__ + "static/media/BellSimple.c38934c9e5a644daeea1e73fd79540b7.svg";
export { ForwardRef as ReactComponent };